import { render, staticRenderFns } from "./SectionManage.vue?vue&type=template&id=4377d0a4&scoped=true&"
import script from "./SectionManage.vue?vue&type=script&lang=js&"
export * from "./SectionManage.vue?vue&type=script&lang=js&"
import style0 from "./SectionManage.vue?vue&type=style&index=0&id=4377d0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377d0a4",
  null
  
)

export default component.exports